'use es6';

import { getAll as getAllProblems } from '../../private/action-problem-solution/actions/add-static-widget-to-dashboard/problem';
import { getProblem } from '../../private/action-problem-solution/common/get-problem';
import { isEnabled } from '../../private/action-problem-solution/common/is-enabled';
export function canAddStaticWidgetToDashboard(params) {
  return isEnabled(params, getAllProblems);
}
export function getAddStaticWidgetToDashboardProblem(params) {
  return getProblem(params, getAllProblems);
}